<template>
    <div class="info-wrap" v-if="info" @click="close">
        {{info.message}}
    </div>
</template>

<script>
export default {
    props: {
        info: Object
    },
    methods: {
        close(){
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.info-wrap {
    z-index: 9999;
    max-width: calc(min(300px, 70vw));
    position: fixed;
    padding: 15px;
    top: 80px;
    right: 50px;
    background: linear-gradient(90deg, #0843a8 40%, #1d54b1 85%);
    color: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-word;
}
</style>